
  import atlas from "@/components/atlas.vue";
  import { eventUploadMixin, trackLoginImpression } from '@/plugins/hwtag/events';

  /** 识别社区作品内链，href 仍使用完整地址 */
  function winnerGalleryPath(url) {
    const matched = String(url || '').match(/community\.xp-pen\.com(\/gallery\/\d+)/);
    return matched ? matched[1] : '';
  }

  function winnerWork(name, url, img) {
    return {
      name,
      url,
      img: 'en/' + img,
      path: winnerGalleryPath(url)
    };
  }

  const WINNER_WORKS = {
    gold: [
      winnerWork('LorenaDibuja', 'https://community.xp-pen.com/gallery/55436', 'img_golden_1.webp')
    ],
    silver: [
      winnerWork('bliwi', 'https://community.xp-pen.com/gallery/55653', 'img_silver_1.webp'),
      winnerWork('李薄含', 'https://www.xiaohongshu.com/discovery/item/6ad1d4d2000000001a0301a5?source=webshare&xhsshare=pc_web&xsec_token=AB3KqnvmesJreVv-P-TaVuy-o7riMAaK_22GIOdywneqo=&xsec_source=pc_share', 'img_silver_2.webp'),
      winnerWork('Lixsotan', 'https://community.xp-pen.com/gallery/55076', 'img_silver_3.webp'),
      winnerWork('FIYYNIVERSE', 'https://community.xp-pen.com/gallery/54104', 'img_silver_4.webp'),
      winnerWork('JesusChristArt', 'https://community.xp-pen.com/gallery/54165', 'img_silver_5.webp')
    ],
    bronze: [
      winnerWork('aurorexrm', 'https://community.xp-pen.com/gallery/55052', 'img_bronzn_1.webp'),
      winnerWork('MB77ART', 'https://community.xp-pen.com/gallery/55625', 'img_bronzn_2.webp'),
      winnerWork('DANIOO', 'https://community.xp-pen.com/gallery/54107', 'img_bronzn_3.webp'),
      winnerWork('justmoz', 'https://community.xp-pen.com/gallery/54700', 'img_bronzn_4.webp'),
      winnerWork('evecollectibles', 'https://community.xp-pen.com/gallery/55107', 'img_bronzn_5.webp'),
      winnerWork('Cen', 'https://community.xp-pen.com/gallery/53959', 'img_bronzn_6.webp'),
      winnerWork('王鹏', 'https://www.xiaohongshu.com/discovery/item/6aa7deb0000000002900d7af?source=webshare&xhsshare=pc_web&xsec_token=ABDNot0YrvVjCbELIfyS_a2rjjkteGuohgiDnAj4HPo9k=&xsec_source=pc_share', 'img_bronzn_7.webp'),
      winnerWork('XFANSpss6sx88', 'https://community.xp-pen.com/gallery/55204', 'img_bronzn_8.webp')
    ],
    excellence: [
      winnerWork('Miktlan', 'https://community.xp-pen.com/gallery/54967', 'img_excellency_1.webp'),
      winnerWork('PONYA', 'https://community.xp-pen.com/gallery/55601', 'img_excellency_2.webp'),
      winnerWork('Meoreo', 'https://community.xp-pen.com/gallery/55546', 'img_excellency_3.webp'),
      winnerWork('Pinkii chan', 'https://community.xp-pen.com/gallery/55679', 'img_excellency_4.webp'),
      winnerWork('Tokwa07', 'https://community.xp-pen.com/gallery/54958', 'img_excellency_5.webp'),
      winnerWork('XFANS4a8dk8cp', 'https://community.xp-pen.com/gallery/55450', 'img_excellency_6.webp'),
      winnerWork('mauzeart', 'https://community.xp-pen.com/gallery/55646', 'img_excellency_7.webp'),
      winnerWork('Thedanielhd', 'https://community.xp-pen.com/gallery/54785', 'img_excellency_8.webp'),
      winnerWork('akaria', 'https://community.xp-pen.com/gallery/54705', 'img_excellency_9.webp'),
      winnerWork('itsHarlin', 'https://community.xp-pen.com/gallery/54621', 'img_excellency_10.webp'),
      winnerWork('Shlawg', 'https://community.xp-pen.com/gallery/54337', 'img_excellency_11.webp'),
      winnerWork('Nicolael', 'https://community.xp-pen.com/gallery/54087', 'img_excellency_12.webp'),
      winnerWork('yuanyastr', 'https://community.xp-pen.com/gallery/53962', 'img_excellency_13.webp'),
      winnerWork('XFANSgjjr3z7y', 'https://community.xp-pen.com/gallery/55364', 'img_excellency_14.webp'),
      winnerWork('Mod227', 'https://community.xp-pen.com/gallery/55234', 'img_excellency_15.webp'),
      winnerWork('XFANSpdp3o3kr', 'https://community.xp-pen.com/gallery/54083', 'img_excellency_16.webp'),
      winnerWork('Pablo070495', 'https://community.xp-pen.com/gallery/54639', 'img_excellency_17_new.webp'),
      winnerWork('P4njuls', 'https://community.xp-pen.com/gallery/55499', 'img_excellency_18.webp'),
      winnerWork('GissyPio', 'https://community.xp-pen.com/gallery/54253', 'img_excellency_19.webp'),
      winnerWork('XFANSci5dd26d', 'https://community.xp-pen.com/gallery/54347', 'img_excellency_20.webp')
    ],
    special: [
      winnerWork('Olber', 'https://community.xp-pen.com/gallery/55398', 'img_special_1_new.jpg'),
      winnerWork('dcd', 'https://community.xp-pen.com/gallery/55535', 'img_special_2.webp'),
      winnerWork('abandonshapes', 'https://community.xp-pen.com/gallery/55425', 'img_special_3.webp')
    ]
  };

  /** 祝贺说明各语种都用英文，直接写在页面 */
  /** 获奖说明。url 有值时在段落下单独放可点击地址 */
  const WINNER_NOTES = [
    { text: 'Please note that if any winner is found to have violated any of the established rules, their award will be automatically disqualified.' },
    { text: 'We will contact the winners via email within 7 business days of the results announcement.' },
    { text: 'If you are a winner, please check your email (including your spam folder) for relevant instructions within 10 days of the results announcement, or send an email to community@xp-pen.com for award information. If we cannot contact the winner within 10 days, their award will be disqualified, and we will select another winner.' },
    { text: 'The XPPen contest is ongoing and continues to grow. Thank you for choosing XPPen as your partner; we are delighted to witness your journey in pursuing your artistic dreams.' },
    { text: 'XPPen will always be there for you, helping you enjoy drawing, inspiring your creativity, and giving you unlimited creative space.' },
    { text: 'We look forward to your participation in the next contest.' },
    {
      text: 'For the China Region winners, please visit the corresponding event page:',
      url: 'https://www.xp-pen.com.cn/topic/global-art-toy-design-contest.html'
    },
    { text: '*XPPen and TOP TOY reserve the final right of interpretation concerning this competition and related IP matters.' }
  ];

  export default {
    mixins: [eventUploadMixin],
    data() {
      return {
        navId: 0,
        tab: 0,
        navActive:'winner',
        activePage: 'winner', // 进入活动页默认展示获奖作品
        winnerNoteList: WINNER_NOTES,
        activeTab: 0,
        activeTab2: 0,
        activeGiftTip: null,
        tabs:[
          { label: 'Registration' },
          { label: 'Discussion' },
          { label: 'Follow Us' }
        ],
        // 屏幕滚动
        scrollTop: 0,
        currentPage: 1,
        source: '',
        bannerH: 0,
        headerH: 0,
        navTopHeight: 0,
        WindowWidth:'',
        imgUrl: 'https://resource.xp-pen.com/img/Contest/AnniversaryContest26/',
        sidebar: 'en',
        persistanceList:['/user/323647', '/user/323643', '/user/322390'],
        progressList:['/user/321939', '/user/321740', '/user/300763', '/user/274337','/user/323470','/user/321617','/user/273567', '/user/319844','/user/300246','/user/281303'],
        activeList:['/user/272402', '/user/325077', '/user/323424','/user/321217','/user/308261','/user/323281','/user/323463','/user/323337','/user/324088','/user/159570'],
        email: "",
        emailError: "",
        successTimer: null,
        successVisible: false,
        submitDebounce: false,
        pendingUploadAfterLogin: false,
        sliderList: [
          {
            type: 'en',
            lang: 'English',
            langText: '英语'
          },
          {
            type: 'de',
            lang: 'Deutsch',
            langText: '德语'
          },
          {
            type: 'es',
            lang: 'Español',
            langText: '西班牙语'
          },
          {
            type: 'pt',
            lang: 'Português',
            langText: '葡萄牙语'
          },
          {
            type: 'it',
            lang: 'Italiano',
            langText: '意大利语'
          },
          {
            type: 'fr',
            lang: 'Français',
            langText: '法语'
          },
          {
            type: 'jp',
            lang: '日本語',
            langText: '日语'
          },
          {
            type: 'kr',
            lang: '한국어',
            langText: '韩语'
          },
          {
            type: 'pl',
            lang: 'Polska',
            langText: '波兰语'
          },
          {
            type: 'ru',
            lang: 'Русский язык',
            langText: '俄语'
          },
          {
            type: 'yn',
            lang: 'Tiếng Việt',
            langText: '越南语'
          },
          {
            type: 'tw',
            lang: '繁体中文',
            langText: '繁体中文'
          }
        ],
      };
    },
    head() {
      // 优化seo：动态设置title，keywords 和 description
      // 越南语站点引入思源字体（Noto Sans）语言包
      const link = this.sidebar === 'vn'
        ? [
            { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
            { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: true },
            {
              rel: 'stylesheet',
              href: 'https://fonts.googleapis.com/css2?family=Darumadrop+One&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Kaushan+Script&family=Noto+Sans+SC:wght@100..900&family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=PT+Serif+Caption:ital@0;1&display=swap'
            }
          ]
        : [];
      return {
        title: "XPPen × TOP TOY Global Art Toy Design Contest",
        meta: [
          {
            name: "keywords",
            content: "2026, XPPen, Drawing Contest, XPPen × TOP TOY Global Art Toy Design Contest",
          },
          {
            hid: "description",
            name: "names",
            content: "XPPen × TOP TOY Global Art Toy Design Contest is a global art toy design contest organized by XPPen and TOP TOY. It is a platform for artists to showcase their creativity and talent.",
          },
        ],
        link
      };
    },
    components: { atlas },
    computed: {
      contestIntroContent() {
        const desc = this.$t('globalArtToyDesignContest.ABOUT_DESC') || '';
        const [question = '', ...bodyParts] = desc.trim().split(/\n\n+/);
        return {
          question,
          body: bodyParts.join('\n\n').trim()
        };
      },
      creativeBriefSections() {
        return [
          {
            title: this.$t('globalArtToyDesignContest.BRIEF_TITLE'),
            content: this.$t('globalArtToyDesignContest.BRIEF_CONTENT')
          },
          {
            title: this.$t('globalArtToyDesignContest.THEMES_TITLE'),
            content: this.$t('globalArtToyDesignContest.THEMES_CONTENT')
          },
          {
            title: this.$t('globalArtToyDesignContest.GUIDELINES_TITLE'),
            content: this.$t('globalArtToyDesignContest.GUIDELINES_CONTENT')
          },
          {
            title: this.$t('globalArtToyDesignContest.SUBMISSION_RULES_TITLE'),
            content: this.$t('globalArtToyDesignContest.SUBMISSION_RULES_CONTENT')
          }
        ];
      },
      submissionChannelCards() {
        const getPlainText = (value) => String(value || '').replace(/<[^>]*>/g, '').trim();

        return [
          {
            type: 'global',
            title: getPlainText(this.$t('globalArtToyDesignContest.GLOBAL_LABEL')),
            desc: this.$t('globalArtToyDesignContest.GLOBAL_DESC')
          },
          {
            type: 'china',
            title: getPlainText(this.$t('globalArtToyDesignContest.CHINA_LABEL')),
            desc: this.$t('globalArtToyDesignContest.CHINA_DESC')
          }
        ];
      },
      contestAwardCards() {
        return [
          {
            type: 'gold',
            size: 'major',
            title: this.$t('globalArtToyDesignContest.GOLD_AWARD'),
            productName: this.$t('globalArtToyDesignContest.GOLD_PRIZE_1'),
            productImg: 'img_anni_44.webp',
            cash: this.$t('globalArtToyDesignContest.GOLD_PRIZE_2'),
            points: this.$t('globalArtToyDesignContest.GOLD_PRIZE_3'),
            giftText: this.$t('globalArtToyDesignContest.GOLD_PRIZE_4'),
            giftDetails: [
              this.$t('globalArtToyDesignContest.GOLD_PRIZE_4'),
              this.$t('globalArtToyDesignContest.GOLD_PRIZE_5')
            ],
            giftImg: 'img_anni_11_new.png'
          },
          {
            type: 'silver',
            size: 'major',
            title: this.$t('globalArtToyDesignContest.SILVER_AWARD'),
            productName: this.$t('globalArtToyDesignContest.SILVER_PRIZE_1'),
            productImg: 'img_anni_45.webp',
            cash: this.$t('globalArtToyDesignContest.SILVER_PRIZE_2'),
            points: this.$t('globalArtToyDesignContest.SILVER_PRIZE_3'),
            giftText: this.$t('globalArtToyDesignContest.SILVER_PRIZE_4'),
            giftDetails: [this.$t('globalArtToyDesignContest.SILVER_PRIZE_4')],
            giftImg: 'img_anni_38.webp'
          },
          {
            type: 'bronze',
            size: 'minor',
            title: this.$t('globalArtToyDesignContest.BRONZE_AWARD'),
            productName: this.$t('globalArtToyDesignContest.BRONZE_PRIZE_1'),
            productImg: 'img_anni_46.webp',
            cash: this.$t('globalArtToyDesignContest.BRONZE_PRIZE_2'),
            points: this.$t('globalArtToyDesignContest.BRONZE_PRIZE_3'),
            giftText: this.$t('globalArtToyDesignContest.BRONZE_PRIZE_4'),
            giftDetails: [this.$t('globalArtToyDesignContest.BRONZE_PRIZE_4')],
            giftImg: 'img_prize_23.png'
          },
          {
            type: 'excellence',
            size: 'minor',
            title: this.$t('globalArtToyDesignContest.EXCELLENCE_AWARD'),
            productName: this.$t('globalArtToyDesignContest.EXCELLENCE_PRIZE_1'),
            productImg: 'img_anni_47.webp',
            points: this.$t('globalArtToyDesignContest.EXCELLENCE_PRIZE_2'),
            giftText: this.$t('globalArtToyDesignContest.EXCELLENCE_PRIZE_3'),
            giftDetails: [this.$t('globalArtToyDesignContest.EXCELLENCE_PRIZE_3')],
            giftImg: 'img_anni_22.webp'
          },
          {
            type: 'special',
            size: 'minor',
            title: this.$t('globalArtToyDesignContest.SPECIAL_AWARD'),
            productName: this.$t('globalArtToyDesignContest.SPECIAL_PRIZE_1'),
            productImg: 'img_anni_48.webp',
            points: this.$t('globalArtToyDesignContest.SPECIAL_PRIZE_2'),
            giftText: this.$t('globalArtToyDesignContest.SPECIAL_PRIZE_3'),
            giftDetails: [this.$t('globalArtToyDesignContest.SPECIAL_PRIZE_3')],
            giftImg: 'img_anni_39.webp'
          }
        ];
      },
      majorAwardCards() {
        return this.contestAwardCards.filter(item => item.size === 'major');
      },
      minorAwardCards() {
        return this.contestAwardCards.filter(item => item.size === 'minor');
      },
      /** 获奖作品：图片、作者和发布链接按奖项顺序对应 */
      winnerGroups() {
        return this.contestAwardCards
          .filter(item => WINNER_WORKS[item.type])
          .map(item => ({
            ...item,
            slots: WINNER_WORKS[item.type]
          }));
      },
      judgeCards() {
        const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

        return [
          {
            type: 'katun',
            name: cleanText(this.$t('globalArtToyDesignContest.JUDGE_KATUN_NAME')),
            desc: this.$t('globalArtToyDesignContest.JUDGE_KATUN_DESC'),
            img: 'img_anni_17.webp'
          },
          {
            type: 'josephine',
            name: cleanText(this.$t('globalArtToyDesignContest.JUDGE_JOSEPHINE_NAME')),
            desc: this.$t('globalArtToyDesignContest.JUDGE_JOSEPHINE_DESC'),
            img: 'img_anni_18.webp'
          },
          {
            type: 'jun',
            name: cleanText(this.$t('globalArtToyDesignContest.JUDGE_JUN_NAME')),
            desc: this.$t('globalArtToyDesignContest.JUDGE_JUN_DESC'),
            img: 'img_anni_19.webp'
          },
          {
            type: 'toptoy',
            name: cleanText(this.$t('globalArtToyDesignContest.JUDGE_TOPTOY_NAME')),
            desc: this.$t('globalArtToyDesignContest.JUDGE_TOPTOY_DESC'),
            img: 'img_anni_20.webp'
          }
        ];
      },
      judgingCriteriaCards() {
        return [
          {
            type: 'artistic',
            title: this.$t('globalArtToyDesignContest.CRITERIA_ARTISTIC').trim(),
            desc: this.$t('globalArtToyDesignContest.CRITERIA_ARTISTIC_DESC'),
            points: 40,
            icon: 'img_anni_30.webp'
          },
          {
            type: 'theme',
            title: this.$t('globalArtToyDesignContest.CRITERIA_THEME'),
            desc: this.$t('globalArtToyDesignContest.CRITERIA_THEME_DESC'),
            points: 40,
            icon: 'img_anni_31.webp'
          },
          {
            type: 'feasibility',
            title: this.$t('globalArtToyDesignContest.CRITERIA_FEASIBILITY'),
            desc: this.$t('globalArtToyDesignContest.CRITERIA_FEASIBILITY_DESC'),
            points: 20,
            icon: 'img_anni_32.webp'
          }
        ];
      },
      termsConditionsData() {
        const raw = String(this.$t('globalArtToyDesignContest.TERMS_CONDITIONS_CONTENT') || '').trim();
        const splitMatch = raw.match(/^([\s\S]*?)\n\n(?=\d+\.)([\s\S]*)$/);
        let intro = '';
        let listPart = raw;
        if (splitMatch) {
          intro = splitMatch[1].trim();
          listPart = splitMatch[2].trim();
        }
        const items = [];
        const re = /(\d+)\.\s*([\s\S]*?)(?=\n\d+\.|$)/g;
        let match;
        while ((match = re.exec(listPart)) !== null) {
          items.push({
            num: match[1],
            text: match[2].trim()
          });
        }
        return { intro, items };
      },
      copyrightTermsData() {
        const raw = String(this.$t('globalArtToyDesignContest.COPYRIGHT_CONTENT') || '').trim();
        const items = [];
        const re = /(\d+)\.\s*([\s\S]*?)(?=\n\d+\.|$)/g;
        let match;
        while ((match = re.exec(raw)) !== null) {
          items.push({
            num: match[1],
            text: match[2].trim()
          });
        }
        return items;
      },
      faqData() {
        const raw = String(this.$t('globalArtToyDesignContest.FAQ_CONTENT') || '').trim();
        if (!raw) return [];
        // Q/F/P/D/В + A/R/O/О cover EN/DE/ES/FR/IT/PT/PL/RU/JP/KR/TW/VN prefixes
        const questionSplit = /(?:^|\n)(?=(?:Q|F|P|D|В)\s*[:.：])/;
        const answerStart = /\n(?=(?:A|R|O|О)\s*[:.：])/;
        return raw.split(questionSplit).map((block) => block.trim()).filter(Boolean).map((block) => {
          const answerMatch = block.match(answerStart);
          if (answerMatch) {
            const idx = answerMatch.index;
            return {
              question: block.slice(0, idx).trim(),
              answer: block.slice(idx + 1).trim()
            };
          }
          const firstBreak = block.indexOf('\n');
          if (firstBreak === -1) {
            return { question: block, answer: '' };
          }
          return {
            question: block.slice(0, firstBreak).trim(),
            answer: block.slice(firstBreak + 1).trim()
          };
        });
      }
    },
    watch: {
      // 站点语种切换后，比赛页侧边栏高亮与文案保持一致
      '$i18n.locale'(locale) {
        const lang = this.normalizeContestLang(locale);
        if (lang && this.sidebar !== lang) {
          this.sidebar = lang;
        }
      },
      '$store.state.isLogin'(loggedIn) {
        if (loggedIn && this.pendingUploadAfterLogin) {
          this.pendingUploadAfterLogin = false;
          this.goToReleaseWork();
        }
      },
    },
    created() {
      // 进入页面时跟随网站当前语种（query.lang 优先）
      const lang = this.resolveContestLang(
        this.$route.query.lang || this.$i18n.locale || this.$store.state.locale
      );
      this.sidebar = lang;
      if (this.$i18n.locale !== lang) {
        this.$loadLanguageAsync(lang);
      }
    },
    mounted() {
      this.WindowWidth = window.innerWidth;
      this.calculateBannerHeight();
      window.addEventListener('scroll', this.handleScroll, true);
      window.addEventListener('load', this.calculateBannerHeight); // Recalculate after all assets load
      window.addEventListener('resize', this.calculateBannerHeight);
      this.parametricWork();
      this.updateNavActive();
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('load', this.calculateBannerHeight);
      window.removeEventListener('resize', this.calculateBannerHeight);
    },
    methods: {
      calculateBannerHeight() {
        if (this.$refs.bannerHeight) {
          this.bannerH = this.$refs.bannerHeight.offsetHeight;
        }
        const headerContainer = document.querySelector('header .container');
        this.navTopHeight = document.querySelector('header').offsetHeight;
        if (headerContainer) {
          this.headerH = headerContainer.offsetHeight;
        }
        this.updateNavActive();
      },
      // 作品方法
      async parametricWork(type, page = 1) {
        const activityId = process.env.NODE_ENV === 'development' ? 149 : 66;
        let res = await this.$global.parametricWork({ activityId, page, award: 0 });
        // res.code = '200' ? (this.source = res.result) : []
        this.source = res;
      },
      // 分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.parametricWork(28, this.currentPage);
      },
      // 滚动方法
      handleScroll() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        this.updateNavActive();
      },
      // 更新导航激活状态
      updateNavActive() {
        if (this.activePage === 'terms' || this.activePage === 'gallery' || this.activePage === 'winner') {
          this.navActive = this.activePage;
          return;
        }

        const sections = [
          { id: 'contestInfo', nav: 'contestInfo' },
          { id: 'upload', nav: 'upload' }
        ];

        const navContent = document.getElementById('navContent');
        const navHeight = navContent ? navContent.offsetHeight : 0;
        const headerHeight = this.headerH;

        let activeNav = '';
        // 考虑固定导航栏和头部的高度，以及一个小的偏移量，使高亮更平滑
        const scrollPosition = this.scrollTop + navHeight + headerHeight + 1;

        for (let i = sections.length - 1; i >= 0; i--) {
          const sectionElement = document.getElementById(sections[i].id);
          if (sectionElement) {
            const sectionTop = sectionElement.offsetTop - 100;
            const sectionBottom = sectionTop + sectionElement.offsetHeight;

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              activeNav = sections[i].nav;
              break;
            }
          }
        }
        this.navActive = activeNav;
      },
      //侧边导航锚点滚动 / 页面切换
      handleScrollTo(id) {
        if (id === 'terms' || id === 'gallery' || id === 'winner') {
          this.activePage = id;
          this.navActive = id;
          this.$nextTick(() => {
            const top = Math.max(this.bannerH - this.headerH, 0);
            window.scroll({ top, behavior: 'smooth' });
          });
          return;
        }

        const scrollToSection = () => {
          const element = document.getElementById(id);
          const navHeight = document.getElementById('navContent');
          if (!element || !navHeight) return;
          const top = (element.getBoundingClientRect().top + window.pageYOffset) - navHeight.offsetHeight - 100;
          window.scroll({ top, behavior: 'smooth' });
          this.navActive = id;
          this.navId = 1;
        };

        if (this.activePage !== 'main') {
          this.activePage = 'main';
          this.navActive = id;
          this.$nextTick(() => {
            scrollToSection();
          });
          return;
        }

        scrollToSection();
      },
      normalizeContestLang(lang) {
        let locale = String(lang || '').trim();
        if (locale === 'vn') locale = 'yn';
        return this.sliderList.some((item) => item.type === locale) ? locale : '';
      },
      resolveContestLang(lang) {
        return this.normalizeContestLang(lang) || 'en';
      },
      //语言栏切换
      changeLanguage(lang) {
        const locale = this.resolveContestLang(lang);
        this.sidebar = locale;
        this.$loadLanguageAsync(locale);
      },
      getTitleParts(text) {
        const words = String(text || '').trim().split(/\s+/).filter(Boolean);
        return words.map((word, index) => ({
          word,
          isLast: index === words.length - 1
        }));
      },
      showGiftTip(type) {
        this.activeGiftTip = type;
      },
      hideGiftTip() {
        this.activeGiftTip = null;
      },
      toggleGiftTip(type) {
        this.activeGiftTip = this.activeGiftTip === type ? null : type;
      },
      //rules tab
      handelTab (tabIndex) {
        this.tab = tabIndex;
      },
      // 注册
      handelReg () {
        if(!this.$store.state.isLogin) {
          this.$jumpTerminus(2);
        }
      },
      // rules tab
      handleTab (tabIndex) {
        this.tab = tabIndex;
      },
      // 埋点
      handleTrack (clickType, clickName, linkDomain, linkUrl) {
        this.$track("promotion_page_click", {
          promotion_type:"2026年21周年庆活动",
          item_skuid:"null",
          item_sku_name:"null",
          item_sku_key_name:"null",
          link_domain:linkDomain,
          link_url:linkUrl,
          click_type:clickType,
          click_name:clickName
        })
      },
      isFlutterApp () {
        return typeof window !== 'undefined'
          && window.FlutterChannel
          && typeof window.FlutterChannel.postMessage === 'function'
      },
      //上传作品
      goToReleaseWork () {
        this.$router.push({ path: '/releaseWork', query: { type: 1 } })
      },
      handleUpload (clickType, clickName, event) {
        if (event) event.preventDefault()
        if (this.isFlutterApp()) {
          this.handleTrack(clickType, clickName, 'https://community.xp-pen.com', 'https://community.xp-pen.com/releaseWork?type=1')
          window.FlutterChannel.postMessage(JSON.stringify({ action: 'public_work' }))
          return
        }
        if(!this.$store.state.isLogin) {
          this.pendingUploadAfterLogin = true
          trackLoginImpression('点击', '参与比赛', 'Submit your entry');
          const useNewLogin = this.$store.state.siteConfig && this.$store.state.siteConfig.DialogPassportSwitch == '1';
          if (useNewLogin) {
            this.$store.commit('OPEN_AUTH_MODAL', {
              tab: 'login',
              redirectToUserCenter: false,
              source: { elementTypeName: '参与比赛', clickName: 'Submit your entry' },
            });
          } else {
            this.$jumpTerminus(1);
          }
          this.handleTrack(clickType, clickName, 'null', 'null')
          return
        }
        this.handleTrack(clickType, clickName, 'https://community.xp-pen.com', 'https://community.xp-pen.com/releaseWork?type=1')
        this.goToReleaseWork()
      },
    },
  };
  